module.exports = __webpack_public_path__ + "img/munchies.f0cf6706.svg";